<template>
<div class="analytics analytics-customers">
  <row>
    <el-tabs v-model="tab" type="border-card" @tab-click="tabClick">
      <!-- General status start -->
      <el-tab-pane :label="$t('Views.Analytics.Customer.generalStatus')" name="first">
        <row>
          <div class="sl-col-4">
            <div class="sl-body">
              <p class="sl-name">{{$t('Chart.customerGrowthChart')}}</p>
              <p class="text-center">
                <el-radio-group v-model="first.customersRadio">
                  <el-radio-button label="op1" @click.native="resetFirstCustomersOp('week','Recent 7 days')" :option="first.customersOption.week">{{$tc('Date.dateRange',0)}}</el-radio-button>
                  <el-radio-button label="op2" @click.native="resetFirstCustomersOp('month','Recent 30 days')" :option="first.customersOption.month">{{$tc('Date.dateRange',1)}}</el-radio-button>
                  <el-radio-button label="op3" @click.native="resetFirstCustomersOp('year','Recent 12 months')" :option="first.customersOption.year">{{$tc('Date.dateRange',2)}}</el-radio-button>
                </el-radio-group>
              </p>
              <chart :options="first.customersOption.default" ref="firstCustomers" auto-resize theme="default"></chart>
            </div>
          </div>
        </row>
      </el-tab-pane>
      <el-tab-pane :label="$t('Views.Analytics.Customer.customerCategories')" name="third">
        <row>
          <div class="sl-col-4">
            <div class="box-header with-border ui-sortable-handle" style="cursor: move;">
              <h3 class="box-title">{{$t('Chart.customerCategories')}}</h3>
              <div class="box-tools pull-right"> <button type="button" class="btn btn-box-tool" data-widget="collapse">
                      </button> </div>
            </div>
            <div class="sl-body">
              <row>
                <div class="col-md-4">
                  <p class="text-center">{{$t('Chart.customerStatus')}}</p>
                  <div class="chart col-lg-3">
                    <chart :options="third.customerStatusOption" ref="thirdCustomerStatus" auto-resize theme="default"></chart>
                  </div>
                </div>
                <div class="col-md-8">
                  <el-table :data='third.customerStatusTable' border>
                    <el-table-column min-width="100" :show-overflow-tooltip="true" prop="name" :label="$t('Views.Analytics.Customer.t1h1')"> <template scope="scope">
                        <span class="label" :style="{backgroundColor: scope.row.color}">&nbsp;&nbsp;</span>
                        <span style="margin-left: 10px">{{ scope.row.category }}</span>
                      </template> </el-table-column>
                    <el-table-column min-width="300" :show-overflow-tooltip="true" prop="def" :label="$t('Views.Analytics.Customer.t1h2')"> </el-table-column>
                    <el-table-column min-width="250" :show-overflow-tooltip="true" prop="value" :label="$t('Views.Analytics.Customer.t1h3')"> </el-table-column>
                  </el-table>
                </div>
              </row>
              <row>
                <div class="col-md-4">
                  <p class="text-center">{{$t('Chart.customerFrequency')}}</p>
                  <div class="chart col-lg-3">
                    <chart :options="third.customerFrequencyOption" ref="thirdCustomerFrequency" auto-resize theme="default"></chart>
                  </div>
                </div>
                <div class="col-md-8">
                  <el-table :data='third.customerFrequencyTable' border>
                    <el-table-column min-width="100" :show-overflow-tooltip="true" prop="name" :label="$t('Views.Analytics.Customer.t2h1')"> <template scope="scope">
                              <span class="label" :style="{backgroundColor: scope.row.color}">&nbsp;&nbsp;</span>
                              <span style="margin-left: 10px">{{ scope.row.category }}</span>
                            </template> </el-table-column>
                    <el-table-column min-width="300" :show-overflow-tooltip="true" prop="def" :label="$t('Views.Analytics.Customer.t2h2')"> </el-table-column>
                    <el-table-column min-width="250" :show-overflow-tooltip="true" prop="value" :label="$t('Views.Analytics.Customer.t2h3')"> </el-table-column>
                  </el-table>
                </div>
              </row>
              <row>
                <div class="col-md-4">
                  <p class="text-center">{{$t('Chart.customerContribution')}}</p>
                  <div class="chart col-lg-3">
                    <chart :options="third.customerContributionOption" ref="thirdCustomerContribution" auto-resize theme="default"></chart>
                  </div>
                </div>
                <div class="col-md-8">
                  <el-table :data='third.customerContributionTable' border>
                    <el-table-column min-width="100" :show-overflow-tooltip="true" prop="name" :label="$t('Views.Analytics.Customer.t3h1')"> <template scope="scope">
                              <span class="label" :style="{backgroundColor: scope.row.color}">&nbsp;&nbsp;</span>
                              <span>{{ scope.row.category }}</span>
                            </template> </el-table-column>
                    <el-table-column min-width="300" :show-overflow-tooltip="true" prop="def" :label="$t('Views.Analytics.Customer.t3h2')"> </el-table-column>
                    <el-table-column min-width="250" :show-overflow-tooltip="true" prop="value" :label="$t('Views.Analytics.Customer.t3h3')"> </el-table-column>
                  </el-table>
                </div>
              </row>
            </div>
          </div>
        </row>
      </el-tab-pane>
      <!-- tab percentage end -->
      <el-tab-pane :label="$t('Views.Analytics.Customer.ARPC')" name="fourth">
        <row>
          <div class="sl-col-2">
            <div class="sl-body">
              <p class="sl-name">{{$t('Chart.arpcByOutlet')}}</p>
              <chart :options="fourth.outletOption" ref="fourthOutlet" auto-resize theme="default"></chart>
            </div>
          </div>
        </row>
      </el-tab-pane>
    </el-tabs>
  </row>
</div>
</template>

<script>
import api from '../../api'
import * as config from '../../util/echart-config'
export default {
  name: 'analytics-customers',
  data() {
    return {
      tab: 'first',
      first: {
        box: [],
        customersRadio: 'op1',
        customersOption: {
          default: null,
          week: {},
          month: {},
          year: {}
        }
      },
      // second: {
      //   customersTime: '00',
      //   customersTimeOptions: NEWCUSTOMERSTIME,
      //   customerChannel: '00',
      //   customerChannelsOptions: CUSTOMERCHANNELS,
      //   newCustomersOption: '',
      //   newCustomersOption1: secondOption.newCustomers.sevenDays,
      //   newCustomersOption2: secondOption.newCustomers.thirtyDays,
      //   newCustomersOption3: secondOption.newCustomers.twelveMonths,
      //   newCustomersRadio: 'Recent 7 days',
      //   retentionOption: ''
      // },
      third: {
        customerStatusOption: null,
        customerFrequencyOption: null,
        customerContributionOption: null,
        customerStatusTable: [],
        customerFrequencyTable: [],
        customerContributionTable: [],
        categoryRadio: 'all',
        categoryRadioArr: [],
        categoryTableAllData: [],
        categoryTableData: []
      },
      fourth: {
        outletOption: null
      }
    }
  },
  methods: {
    tabClick() {
      const vm = this
      if (this.tab === 'first') {
        api.FetchAnalyticsCustomersTabAChart().then(res => {
          const result = res.data.data
          vm.first.customersOption.default = config.getMultipleLineOption(result.week, config)
          vm.first.customersOption.week = createOption(result.week)
          vm.first.customersOption.month = createOption(result.month)
          vm.first.customersOption.year = createOption(result.year)
          vm.$nextTick(function () {
            vm.$refs.firstCustomers.resize()
          })
        })
      } else if (this.tab === 'second') {
        api.FetchAnalyticsTransactionsTabBChart().then(res => {
          const result = res.data.data
          vm.second.channelOption.default = config.getSingleBarOption(result.week, config, result.legend)
          vm.second.channelOption.week = result.week
          vm.second.channelOption.month = result.month
          vm.second.channelOption.year = result.year
          vm.$nextTick(vm.$refs.byChannel.resize())
        })
      } else if (this.tab === 'third') {
        api.FetchAnalyticsCustomersTabBChart().then(res => {
          const result = res.data.data
          const color = ['#c23531', '#61a0a8', '#2f4554']
          const Ylabel = ['Low contribution customers', 'Mid contribution customers', 'High contribution customers']
          vm.third.customerStatusTable = result.category['customerStatus'].map((item, index) => Object.assign({}, item, {
            color: color[index]
          }))
          vm.third.customerFrequencyTable = result.category['customerFrequency'].map((item, index) => Object.assign({}, item, {
            color: color[index]
          }))
          vm.third.customerContributionTable = result.category['customerContribution'].map((item, index) => Object.assign({}, item, {
            color: color[index]
          }))
          vm.third.customerStatusOption = config.getPieOption(result.category['customerStatus'], config, 'Customer status')
          vm.third.customerFrequencyOption = config.getPieOption(result.category['customerFrequency'], config, 'Customer frequency')
          vm.third.customerContributionOption = config.getPieOption(result.category['customerContribution'], config, 'Customer contribution')
          vm.$nextTick(function () {
            vm.$refs.fourthOutlet.resize()
          })
          // detail table
          vm.third.categoryRadioArr = result.detail.map(item => item.total)
          vm.third.categoryTableAllData = result.detail.map((item, index) => Object.assign({}, item, {
            name: Ylabel[index]
          }))
          vm.third.categoryTableData = vm.third.categoryTableAllData[0]
          vm.third.categoryRadio = 'all'
        })
      } else if (this.tab === 'fourth') {
        api.FetchAnalyticsCustomersTabDChart().then(res => {
          const result = res.data.data
          vm.fourth.outletOption = config.getBarOption(result.outlet, config, 'ARPC by store')
          vm.$nextTick(function () {
            vm.$refs.fourthOutlet.resize()
          })
        })
      }
    },
    resetFirstCustomersOp(params, name) {
      this.$refs.firstCustomers.mergeOptions({
        xAxis: [
          {
            data: this.first.customersOption[params].xAxis
          }
        ],
        series: this.first.customersOption[params].yAxis
      })
    },
    swithThirdTableData(index) {
      this.third.categoryTableData = this.third.categoryTableAllData[index]
    }
  },
  created() {
    const vm = this
    api.FetchAnalyticsCustomersTabABox().then(res => {
      vm.first.box = res.data.data
    })
    api.FetchAnalyticsCustomersTabAChart().then(res => {
      const result = res.data.data
      vm.first.customersOption.default = config.getMultipleLineOption(result.week, config)
      vm.first.customersOption.week = createOption(result.week)
      vm.first.customersOption.month = createOption(result.month)
      vm.first.customersOption.year = createOption(result.year)
      vm.$nextTick(function () {
        vm.$refs.firstCustomers.resize()
      })
    })
  }
}

function createOption(op) {
  op.yAxis = op.yAxis.map(item => ({
    name: item.name,
    data: item.value,
    type: 'line'
  }))
  return op
}
</script>



// WEBPACK FOOTER //
// customers.vue?7e3fb2af